import React, { FC } from "react";
import { Alert, Box } from "@mui/material";
import SubscriptionSelect from "@components/SubscriptionSelect";
import { Trans, useTranslation } from 'react-i18next';
import { DateUtil } from '@utils/date.util';
import { useSelector } from 'react-redux';
import { RootState } from '@store/store';
import { useGetPlanSubscriptionDetailsQuery } from '@store/planApi';
import { isActiveTrial } from '@utils/subscription.util';

const Billing: FC = () => {
  const { t } = useTranslation();
  const selectedPatientId = useSelector(
    (state: RootState) => state.home.selectedPatientId,
  );
  const { data: subscription } = useGetPlanSubscriptionDetailsQuery(
    {
      patientId: selectedPatientId!,
    },
    { skip: !selectedPatientId },
  );
  return (
    <Box display="flex" flexDirection="column">
      {subscription && subscription.expirationDate && isActiveTrial(subscription) && (
        <Alert variant="standard" severity="info" color="info" style={{marginBottom: '20px'}}>
          <Trans
            i18nKey="onboardingBilling.freeTrialMessage"
            values={{
              days: Math.max(
                DateUtil.getDiff(
                  new Date(subscription.createdDate),
                  new Date(subscription.expirationDate),
                )?.days || 0,
                0,
              ),
              planName: t(
                `subscription.plans.${subscription.plan.name}.title`,
              ),
              expirationDate: DateUtil.formatDate(
                subscription.expirationDate,
                "dd MMM yyyy",
              ),
            }}
            components={{ bold: <strong /> }}
          />
        </Alert>
      )}
      <SubscriptionSelect />
    </Box>
  );
};

export default Billing;
